export function getHeightOptions(startInches = 54, count = 31) {
  const options = [];

  for (let i = 0; i < count; i += 1) {
    const totalInches = startInches + i;
    const feet = Math.floor(totalInches / 12);
    const inches = totalInches % 12;
    options.push({ totalInches, feet, inches });
  }

  return options;
}

export function normalizeHeight(value) {
  if (!value) return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  // 1) Already in standard format or with special characters: "6'2"", "6′2″", "6' 2""
  if (trimmed.includes("'") || trimmed.includes("′")) {
    const feetSeparator = trimmed.includes("'") ? "'" : "′";
    const parts = trimmed.split(feetSeparator);
    const rawFeet = parts[0]?.trim() || "";
    const rawInches = parts[1]?.replace(/[^0-9]/g, "").trim() || "0";

    const feet = parseInt(rawFeet, 10);
    const inches = parseInt(rawInches, 10);

    if (!isNaN(feet) && !isNaN(inches) && inches >= 0 && inches < 12) {
      return `${feet}'${inches}"`;
    }
  }

  // 2) Decimal feet: "4.0", "5.8" -> convert to feet/inches
  if (trimmed.includes(".")) {
    const decimalFeet = parseFloat(trimmed);
    if (!isNaN(decimalFeet) && decimalFeet > 0) {
      const feet = Math.floor(decimalFeet);
      const inches = Math.round((decimalFeet - feet) * 12);
      return `${feet}'${inches}"`;
    }
  }

  // 3) Plain number (assumed to be inches): "70" -> convert to feet/inches
  const inchesOnly = parseInt(trimmed, 10);
  if (!isNaN(inchesOnly) && inchesOnly > 0) {
    const feet = Math.floor(inchesOnly / 12);
    const inches = inchesOnly % 12;
    return `${feet}'${inches}"`;
  }

  return null;
}
